export default __webpack_public_path__ + "static/media/error.0a227ea2.gif";